/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { Paragraph, Surface, useTheme } from "react-native-paper";
import { Block } from "@block";
import IconsYellowBanking from "../../icons/icon-yellow-banking/IconsYellowBanking.web";
import { spacing } from "@styles/spacing";
import { QueueSpacing } from "@components/spacing";
import { useTranslation } from "react-i18next";
import ScreenNameType from "@navigation/nav-screens";
import { StackActions } from "@react-navigation/core";
import { Pressable, StyleSheet, TextStyle, ViewStyle } from "react-native";
import { GlobalScreenContext } from "../../global-screen/global-screen";
import { SideMenuContext } from "../../side-menu/side-menu";
import { navigationRef } from "app/shared/util/root-navigator";
import { setTransferLocalReset } from "app/modules/transfer/transfer-local/reducer/actions";
import { useDispatch, useSelector } from "react-redux";
import { setTransfer247Reset } from "app/modules/transfer/transfer-247/reducer/actions";
import { setTopUpReset } from "app/modules/top-up/reducer/actions";
import { setBillingReset } from "app/modules/billings/reducer/actions";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

interface ItemShortcutLinkFunction {
  name: string;
  icon: string;
  id?: string;
  onPress?: () => void;
}

const ShortcutLink = () => {
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const { currentScreen } = React.useContext(GlobalScreenContext);
  const { hideMenu } = React.useContext(SideMenuContext);
  const contactId = useSelector(getContactIdSelector);

  const navigateAction = (screen?: string, params?: any) => {
    hideMenu();
    if (screen?.length) {
      navigationRef?.current?.dispatch(StackActions.replace(screen, params ? params : {}));
    }
  };

  const shortcutLink: Array<ItemShortcutLinkFunction> = [
    {
      icon: "chuyentiennhanhnapas247",
      name: t("TRANFER_CHUYEN_TIEN_NHANH_247"),
      id: ScreenNameType.TRANS_247,
      onPress: () => {
        handlerParamsCleverTap("ct_transfer", "fastfund_napas_247");
        dispatchStore(setTransfer247Reset());
        navigateAction(ScreenNameType.TRANS_247, { resetData: true });
      },
    },
    {
      icon: "chuyentiennoibo",
      name: t("TRANFER_CHUYEN_TIEN_NOI_BO"),
      id: ScreenNameType.TRANS_LOCAL,
      onPress: () => {
        handlerParamsCleverTap("ct_transfer", "the_same_bank");
        dispatchStore(setTransferLocalReset());
        navigateAction(ScreenNameType.TRANS_LOCAL, { resetData: true });
      },
    },
    {
      icon: "naptiendientu",
      name: t("FUNC_DV_NAP_TIEN"),
      id: ScreenNameType.TOP_UP_CREATE,
      onPress: () => {
        handlerParamsCleverTap("ct_billing", undefined, "top_up");
        dispatchStore(setTopUpReset());
        navigateAction(ScreenNameType.TOP_UP_CREATE, { resetData: true });
      },
    },
    {
      icon: "thanhtoanhoadontudong",
      name: t("FUNC_DV_THANH_TOAN_HOA_DON"),
      id: ScreenNameType.BILLINGS_CREATE,
      onPress: () => {
        handlerParamsCleverTap("ct_billing", undefined, "billing_payment");
        dispatchStore(setBillingReset());
        navigateAction(ScreenNameType.BILLINGS_CREATE, { resetData: true });
      },
    },
  ];

  const handlerParamsCleverTap = (eventName: string, ct_transfer_type?: string, ct_billing_type?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_screen: "home_screen",
      ct_error_message: "",
    };
    if (ct_transfer_type) {
      param = {
        ...param,
        ct_transfer_type: ct_transfer_type,
        ct_transfer_status: "success",
      };
    }
    if (ct_billing_type) {
      param = {
        ...param,
        ct_billing_type: ct_billing_type,
        ct_billing_status: "success",
      };
    }

    return {
      eventNameCT: eventName,
      paramsCT: param,
    };
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        pressAble: { flex: 1, borderRadius: 12 },
      }),
    [],
  );

  const surfaceStyles: ViewStyle = {
    borderRadius: 24,
    paddingRight: spacing.huge,
    paddingLeft: spacing.huge,
    paddingVertical: spacing.medium,
  };

  const titleStyles: TextStyle = {
    ...fonts.medium,
    fontSize: 13,
    letterSpacing: 0,
  };

  return (
    <React.Fragment>
      <Surface style={surfaceStyles}>
        {shortcutLink.map((item: ItemShortcutLinkFunction, index) => (
          <Pressable
            key={index}
            style={[styles.pressAble, { backgroundColor: currentScreen === item.id ? colors.backgroundForm : "transparent" }]}
            onPress={item.onPress}>
            <Block center row p={spacing.micro}>
              <IconsYellowBanking name={item.icon} size={48} />
              <QueueSpacing size="small" />
              <Paragraph style={[titleStyles, { color: currentScreen === item.id ? colors.accent : colors.blackText }]}>
                {item.name}
              </Paragraph>
            </Block>
          </Pressable>
        ))}
      </Surface>
    </React.Fragment>
  );
};

export default ShortcutLink;
